export default "__VITE_ASSET__DvmJphkS__"